import type { ReactNode } from 'react'
import {
  AttachmentTypeEnum,
  AttachmentUploadStatusEnum,
} from 'modules/community/types/post-attachment'
import type { GIFObject } from '../api/tenor.types'
import { usePostAttachmentsContext } from './context'
import { GifPicker } from './gif-picker'

export interface GifAttachmentProps {
  className?: string
  iconClassName?: string
  onOpenChange?: (open: boolean) => void
}

export const GifAttachment = ({
  className,
  iconClassName = '',
  onOpenChange,
}: GifAttachmentProps): ReactNode => {
  const { addAttachment } = usePostAttachmentsContext()

  const handleGif = (gif: GIFObject): void => {
    addAttachment({
      id: crypto.randomUUID(),
      status: AttachmentUploadStatusEnum.Success,
      url: gif.url,
      previewUrl: gif.previewUrl,
      type: AttachmentTypeEnum.EmbeddedGif,
    })
  }

  return (
    <GifPicker
      className={className}
      onSelect={handleGif}
      iconClassName={iconClassName}
      onOpenChange={onOpenChange}
    />
  )
}
